<script>
	import { link } from "svelte-spa-router";

	export let klass = ""
	export let url = ""
</script>


<a href={url} class={klass} use:link>
	<slot></slot>
</a>